import Vue from "vue";
import Vuex from "vuex";
import System from "./module/System";
import common from "./module/common";
import getters from "./getters";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    System,
    common,
  },
  getters,
});
